import React, {useCallback, useEffect, useState} from 'react';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import CloseIcon from '@material-ui/icons/Close';
import {makeStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import MenuIcon from '@material-ui/icons/Menu';
import {sendLockerStudioData} from '../analytics/lockerStudio';


const useStyles = makeStyles({
    toggle: {
        position: 'absolute',
        right: '0',
        top: '6px',
        pointerEvents: 'initial',
        '&:hover': {
            'backgroundColor': '#fff'
        },
        color: '#6C797D'

},
    tab: {
        maxWidth: '220px',
        padding: '90px 0 13px'
    },

    toggleClose: {
        position: 'absolute',
        right: '10px',
        top: '6px',
        pointerEvents: 'initial',
        '&:hover': {
            'backgroundColor': '#fff'
        },
        color: '#6C797D'
    }
});


const DrawerNav = ({children, forceClose}) => {
    const classes = useStyles();

    const [open, setOpen] = useState(false);

    const onClose = useCallback(() => setOpen(false), []);
    const onOpen = useCallback(() => setOpen(true), []);
    const onToggleOpen = useCallback((state) => {
        setOpen(state);
        sendLockerStudioData('menu__click', { 'tab_continue': '' });
    }, []);

    useEffect(() => forceClose && setOpen(false), [forceClose]);


    return (
        <>
            {!open && <Button className={classes.toggle} onClick={() => onToggleOpen(true)}><MenuIcon fontSize='large'/></Button>}

            <SwipeableDrawer
                anchor={'right'}
                open={open}
                onClose={onClose}
                onOpen={onOpen}
                style={{zIndex: 1700}}

            >
                <div className={classes.tab}>
                    <Button className={classes.toggle} onClick={() => onToggleOpen(false)}><CloseIcon fontSize='large' className={classes.toggleClose}/></Button>
                    {children}
                </div>
            </SwipeableDrawer>

        </>

    );
};


export default DrawerNav;